import { Dropdown, Input, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";  
import InsideHeader from "../../../components/InsideHeader";  
import { fetchLeaveApp, generateLeaveReport,    } from "../../../features/dropdown/dropdownSlice";
import { dateForHumans, formatPath, previewPaper } from "../../../utils";
import svg27 from "../../../assets/svg/svg27.svg";
import toast from "react-hot-toast";
import AddLeaveModal from "./modal/AddLeaveModal";


export default function LeaveApplicationTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { leaveApp, loading, leaveAppCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);
  const [prodd1, setProdd1] = useState("");

  function handleCancel() {
    setopen(false);
  }

  const filterDataList = searchText
    ? leaveApp?.filter((item) =>
        item?.fmFmlname?.toLowerCase().includes(searchText.toLowerCase())
      )
    : leaveApp;

  const [prodd, setProdd] = useState(""); 

  const handleEdit = () => {
    setopen(true);
  };

  
  const downloadLeaveForm = async () => {
    const res = await dispatch(
      generateLeaveReport({
        laId: prodd1?.laId,
      })
    );
    if (res?.type === "dropdownSlice/generateLeaveReport/fulfilled") {
      const isPDF =
        new TextDecoder().decode(res.payload.slice(0, 4)) === "%PDF";

      const blob = new Blob([res.payload], {
        type: isPDF ? "application/pdf" : "text/csv",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        isPDF ? "leave_application_report.pdf" : "leave_application_report.csv"
      );
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      await toast.success("Generated Successfully");
    } else {
      toast.error("Error generating Report");
    }
  };

  const settingItems = [
    {
      key: "0",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    {
      key: "1",
      label: (
        <div
          onClick={downloadLeaveForm}
          className={`flex  text-[16px] font-sans   !text-lightBlack cursor-pointer`}
        >
          Download Leave Form
        </div>
      ),
    },
  
  ];

  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength - 3) + "...";
    }
    return text;
  };
  const columns = [
    {
      title: "Full Name",
      sorter: (a, b) => a.ppFullname.localeCompare(b.ppFullname),
      render:(item)=>{
        return(
          <div className="whitespace-nowrap">{item}</div>
        )
      },
      dataIndex: "ppFullname",
    },
    {
      title: "LaId",
      sorter: (a, b) => a.laId.localeCompare(b.laId),
      dataIndex: "laId",
    },
    {
      title: "Leave Type",
      sorter: (a, b) => a.ltLvtypename.localeCompare(b.ltLvtypename),
      dataIndex: "ltLvtypename",
    },
    {
      title: "Applied Days",
      dataIndex: "laApldays",
      sorter: (a, b) => a.laApldays.localeCompare - b.laApldays,
    },
    {
      title: "Leave Balance",
      dataIndex: "laBaltotal",
      sorter: (a, b) => a.laBaltotal.localeCompare - b.laBaltotal,
    },
    {
      title: "Substitute",
      sorter: (a, b) => a.laSubstitute.localeCompare(b.laSubstitute),
      render:(item)=>{
        return(
          <div className="whitespace-nowrap">{item}</div>
        )
      },
      dataIndex: "laSubstitute",
    }, 
    {
      title: "Start Date",
      dataIndex: "laStartdate",
      sorter: (a, b) => a.laStartdate.localeCompare(b.laStartdate),
      render: (item) => {
        return (
          <div className="whitespace-nowrap">
            {dateForHumans(item)}
          </div>
        );
      },
    },
    
    {
      title: "End Date",
      width:'300',
      sorter: (a, b) => a.laEnddate.localeCompare(b.laEnddate),
      dataIndex: "laEnddate",
      render: (item) => {
        return <div className="whitespace-nowrap">{dateForHumans(item)}</div>;
      },
    },
    {
      title: "Return Date",
      sorter: (a, b) => a.laReturndate.localeCompare(b.laReturndate),
      render: (item) => {
        return <div className="whitespace-nowrap">{dateForHumans(item)}</div>;
      },
      dataIndex: "laReturndate",
    },
    {
      title: "Reason",
      sorter: (a, b) => a.laReason.localeCompare(b.laReason),
      dataIndex: "laReason",
    },
    {
      title: "Approval Comments",
      sorter: (a, b) => a.laComments.localeCompare(b.laComments),
      dataIndex: "laComments",
    },
    {
      title: "Current Level",
      sorter: (a, b) => a.laLevel.localeCompare - b.laLevel,
      dataIndex: "laLevel",
    },
    {
      title: "Approver",
      sorter: (a, b) => a.apr1.localeCompare(b.apr1),
      render:(item)=>{
        return(
          <div className="whitespace-nowrap">{item}</div>
        )
      },
      dataIndex: "apr1",
    },
    {
      title: "Attachment", 
      dataIndex: "laAttachmentUrl",
      render: (item) => {
        const fileName = formatPath(item);   
        return (
          <Tooltip title={fileName}>
            <div
              className="cursor-pointer text-[#0000FF] whitespace-nowrap overflow-hidden text-ellipsis max-w-[280px]"
              onClick={() => previewPaper(item)}
            >
              {truncateText(fileName, 20)}
            </div>
          </Tooltip>
        );
      },
    },
   
   
    {
      title: "Status",
      dataIndex: "laApproved",
      render: (item) => {
        const colors = {
          1: "#2DD683",
          2: "#FFAB00",
          3: "#9D1500",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[5px] px-2 py-1 w-auto"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {item === 1
              ? "APPROVED"
              : item === 2
              ? "PENDING"
              : item === 3
              ? "REJECTED"
              : null}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd1(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },

   
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchLeaveAppData(page, size) {
   const res = await dispatch(
    fetchLeaveApp({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    ); 
    if(res?.payload?.messages?.message === "PERMISSION DENIED::YOU DON'T HAVE RIGHTS TO EDIT GLOBAL ITEMS"){
      navigate("/roles-error-page");
      return;
    }
  }

  useEffect(() => {
    fetchLeaveAppData();
  }, []);

   

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Leave Application Information"
        subtitle="Manage Leave applications within your institution"
        back={false}
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
           Leave Application Details
          </h3>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center w-full ">
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search Leave application "
                className="text-[16px] font-[400] flex-row-reverse search-input"
                prefix={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.2508 3.75C7.50609 3.75 4.47041 6.93997 4.47041 10.875C4.47041 14.81 7.50609 18 11.2508 18C14.9955 18 18.0312 14.81 18.0312 10.875C18.0312 6.93997 14.9955 3.75 11.2508 3.75ZM3.04297 10.875C3.04297 6.11154 6.71773 2.25 11.2508 2.25C15.7838 2.25 19.4586 6.11154 19.4586 10.875C19.4586 15.6385 15.7838 19.5 11.2508 19.5C6.71773 19.5 3.04297 15.6385 3.04297 10.875Z"
                      fill="#333333"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.045 15.913C16.3237 15.6201 16.7756 15.6201 17.0543 15.913L21.3902 20.4693C21.6689 20.7622 21.6689 21.237 21.3902 21.5299C21.1115 21.8228 20.6596 21.8228 20.3809 21.5299L16.045 16.9737C15.7663 16.6808 15.7663 16.2059 16.045 15.913Z"
                      fill="#333333"
                    />
                  </svg>
                }
              />
            </div>
            
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.fmId}
                columns={columns}
                dataSource={filterDataList}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: leaveAppCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchLeaveAppData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <AddLeaveModal
        handleFetchData={fetchLeaveAppData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd1}
      />
     
    </div>
  );
}
